/* ============================================================
   bundle.js – FINAL VERSION (paired with enforce script)
   ------------------------------------------------------------
   ✔ Adds 2 bundle products with required bundle properties
   ✔ Uses the safest property naming for detection:
       _bundle_id, _is_bundle, _bundle_coupon, _bundle_savings_cents
   ✔ Redirects to /cart?discount=CODE so Shopify applies discount
   ✔ Prevents theme redirects on button click
   ✔ Handles even/odd discount split
   ✔ Fully tested with Shopify Sense theme cart logic
============================================================ */

document.addEventListener("DOMContentLoaded", function () {

  /* Shopify AJAX add-to-cart */
  function addVariant(variantId, qty = 1, props = {}) {
    return fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: variantId,
        quantity: qty,
        properties: props
      })
    }).then(res => {
      if (!res.ok) throw new Error("Add failed: " + res.status);
      return res.json();
    });
  }

  const buttons = document.querySelectorAll(".bundle-btn-add");
  if (!buttons.length) return;

  buttons.forEach(btn => {

    btn.setAttribute("type", "button");
    btn.style.cursor = "pointer";

    btn.addEventListener("click", async function (e) {
      e.preventDefault();
      e.stopPropagation();

      const bundleId = btn.dataset.bundleId || "";
      const v1 = btn.dataset.p1;
      const v2 = btn.dataset.p2;
      const coupon = (btn.dataset.coupon || "").trim();

      // Merchant-defined savings in CENTS
      const savingsRaw = btn.dataset.savingsCents || btn.dataset.savings || "0";
      const savingsCents = Number(savingsRaw) || 0;

      if (!v1 || !v2) {
        console.error("Bundle: variant IDs missing");
        alert("Bundle is not set up correctly.");
        return;
      }

      /* Split discount evenly between two products */
      const half = Math.floor(savingsCents / 2);
      const remainder = savingsCents % 2;
      const save1 = half + remainder;
      const save2 = half;

      /* Properties for each line item */
      const props1 = {
        _bundle_id: bundleId,
        _is_bundle: "true",
        _bundle_coupon: coupon,
        _bundle_savings_cents: String(save1)
      };

      const props2 = {
        _bundle_id: bundleId,
        _is_bundle: "true",
        _bundle_coupon: coupon,
        _bundle_savings_cents: String(save2)
      };

      try {
        btn.disabled = true;
        btn.classList.add("is-loading");

        /* Add both items — parallel = faster */
        await Promise.all([
          addVariant(Number(v1), 1, props1),
          addVariant(Number(v2), 1, props2)
        ]);

        /* Save metadata in browser for reinforcement logic */
        if (coupon) {
          localStorage.setItem("last_added_bundle", bundleId + "|" + coupon);
          localStorage.setItem("last_added_bundle_ts", Date.now().toString());
        }

        /* Redirect to cart and apply coupon */
        if (coupon) {
          window.location.assign(
            "/cart?discount=" + encodeURIComponent(coupon)
          );
        } else {
          window.location.assign("/cart");
        }

      } catch (err) {
        console.error("Bundle add error:", err);
        alert("Could not add bundle. Try again.");
      } finally {
        btn.disabled = false;
        btn.classList.remove("is-loading");
      }
    });
  });
});
